import { ref } from 'vue';

import useInjectScript from '@/composables/useInjectScript';

export const WebEngageSymbol = Symbol();

const WEB_ENGAGE_HTTPS_URL = 'https://ssl.widgets.ir0.webengage.com';
const WEB_ENGAGE_HTTP_URL = 'http://cdn.widgets.ir0.webengage.com';

const WEB_ENGAGE_WEBSITE_ID = 'aa132108';
const WEB_ENGAGE_WEBSITE_VERSION = '6.0';

const WEB_ENGAGE_SESSION_RESET_DURATION = 30 * 1000 * 60;

const api = {
  triggerLogin(value) {
    (window as any).webengage.user.login(value);

    // trigger login event every 30 minutes.
    setInterval(() => {
      (window as any).webengage.user.login(value);
    }, WEB_ENGAGE_SESSION_RESET_DURATION);
  },
  triggerLogout() {
    (window as any).webengage.user.logout();
  },

  setAttribute(attr, value) {
    const whitelist = [
      'we_phone',
      'we_first_name',
      'we_last_name',
      'Has_Activated_Moein',
      'Customer_Has_Balance',
      'Has_Portfolio',
    ];

    if (!whitelist.includes(attr)) {
      return;
    }

    (window as any).webengage.user.setAttribute(attr, value);
  },
  track(attr, value) {
    (window as any).webengage.track(attr, value);
  },

  isReady: ref(false),
  setReadyStatus(value) {
    this.isReady.value = value;
  },
};

const createWebEngageInternalMethod = (target, method) => {
  target[method] = function () {
    // eslint-disable-next-line prefer-rest-params
    (window as any).webengage.__queue.push([`user.${method}`, arguments]);
  };
};

const install = (app) => {
  const methodsLunch = ['init', 'options', 'track', 'screen', 'onReady'];
  const methodsSocket = ['feedback', 'survey', 'notification'];
  const methodsOptions = ['options', 'render', 'clear', 'abort'];
  const methodsState = ['Open', 'Close', 'Submit', 'Complete', 'View', 'Click'];
  const methods = ['identify', 'login', 'logout', 'setAttribute'];

  // https://docs.webengage.com/docs/web-getting-started
  if (!(window as any).webengage || !(window as any).webengage.__v) {
    (window as any).webengage = {
      __queue: [],
      __v: WEB_ENGAGE_WEBSITE_VERSION,
      user: {},
    };

    methodsLunch.forEach((lunch) => {
      createWebEngageInternalMethod((window as any).webengage, lunch);
    });

    methodsSocket.forEach((socket) => {
      (window as any).webengage[socket] = {};

      methodsOptions.forEach((option) => {
        createWebEngageInternalMethod((window as any).webengage[socket], [
          socket,
          option,
        ]);
      });

      methodsState.forEach((state) => {
        createWebEngageInternalMethod((window as any).webengage[socket], [
          socket,
          'on' + state,
        ]);
      });

      methods.forEach((method) => {
        createWebEngageInternalMethod((window as any).webengage.user, method);
      });
    });
  }

  app.provide(WebEngageSymbol, api);

  useInjectScript(
    `${
      'https:' == document.location.protocol
        ? WEB_ENGAGE_HTTPS_URL
        : WEB_ENGAGE_HTTP_URL
    }/js/webengage-min-v-6.0.js`
  ).then(() => {
    (window as any).webengage.init(WEB_ENGAGE_WEBSITE_ID);

    api.setReadyStatus(true);
  });
};

export { install };
